import { useCandidateDetails } from 'src/modules/hooks/useCandidateDetailsQuery';
import { useSelector } from 'src/store/react';
import { selectAuthenticated } from 'src/store/selectors';

const AUTHENTICATED = 'authenticated' as const;
const PENDING = 'pending' as const;
const UNAUTHENTICATED = 'unauthenticated' as const;

export type AuthenticatedType =
  | typeof AUTHENTICATED
  | typeof PENDING
  | typeof UNAUTHENTICATED;

const useAuthenticated = (): AuthenticatedType => {
  const { email, firstName } = useCandidateDetails();

  const isAuthenticated = useSelector(selectAuthenticated);

  const isAuthenticatedOrPending =
    firstName || email ? 'authenticated' : 'pending';
  if (isAuthenticated) {
    if (isAuthenticatedOrPending === 'authenticated') {
      return AUTHENTICATED;
    }
    return PENDING;
  }
  return UNAUTHENTICATED;
};

export default useAuthenticated;
